import Command from '../Command';

class QueryDeviceRegistryCommand extends Command {
	constructor(sender, recipient) {
		super(Command.QUERY_DEVICE_REGISTRY, sender, recipient);
	}
}

export default QueryDeviceRegistryCommand;
